export default __webpack_public_path__ + "static/connatix-835d2e9d2919332264861ccaf0a86f09.svg";